import React from "react";
import styled from "styled-components";

const EventBtn = ({ style, text, onClick }) => {
  return (
    <StyledEventBtn
      style={{
        ...style,
      }}
      onClick={onClick}
    >
      {text ? text : ""}
    </StyledEventBtn>
  );
};

export default EventBtn;

const StyledEventBtn = styled.button.attrs((props) => {})`
  display: flex;
  width: fit-content;
  height: 42px;
  padding: 10px 14px;
  align-items: center;
  justify-content: center;
  border-radius: 23px;
  background: #272829;
  font-family: "Pretendard";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.3%;
  color: #aaa;
  cursor: pointer;
`;
